<div id="modal-content-wrapper">
  <header id="modal-header">
      <h3 id="modal-title">Uso de Cookies</h3>
      <button mat-raised-button
      id="modal-close-button" (click)="closeModal(1)">
      <svg xmlns="http://www.w3.org/2000/svg" width="46.669" height="46.669" viewBox="0 0 46.669 46.669">
        <g id="close" transform="translate(-41.665 -25.665)">
          <rect id="Rectángulo_3" data-name="Rectángulo 3" width="60" height="6"
            transform="translate(45.908 25.665) rotate(45)" fill="#fff" />
          <rect id="Rectángulo_41" data-name="Rectángulo 41" width="60" height="6"
            transform="translate(88.334 29.908) rotate(135)" fill="#fff" />
        </g>
      </svg>
      </button>
  </header>
  <div class="modal-content-custom">
    <p>
      Utilizamos cookies propias y de terceros para mejorar nuestros servicios.
      Si continua con la navegación consideramos que acepta este uso.
      <a href="/terms" target="_blank">Leer más</a>
    </p>
    <div style="display: flex; justify-content: space-around; align-items: center;flex-direction: row; width: 100%;">
      <a  target="_blank" class="btn-theme ts-background-5" (click)="closeModal(0)">Rechazar</a>
      <a  target="_blank" class="btn-theme ts-background-3" (click)="closeModal(1)">Aceptar</a>

    </div>

  </div>
</div>
